var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 子组件1: "+_vm._s(_vm.value)+" "),_c('button',{on:{"click":_vm.change}},[_vm._v("更改")])])}
var staticRenderFns = []

export { render, staticRenderFns }